import { useContext, useMemo } from 'react';
import { LocationFormContext } from '../../../context';
import { DEFAULT_ZOOM_LEVEL } from '../../../const';
import EditMapLanes from './EditMapLanes';
import { useLanesMap } from './useLanesMap';
import { BaseMap } from 'components/maps';
import { Position } from 'types';

export const LanesMap = () => {
  const { values } = useContext(LocationFormContext);
  const { onMapClick } = useLanesMap();

  const viewState = useMemo(() => {
    const coordinates = values?.geometry?.coordinates as Position;

    return coordinates
      ? {
          longitude: coordinates[0],
          latitude: coordinates[1],
          zoom: DEFAULT_ZOOM_LEVEL,
        }
      : undefined;
  }, [values?.geometry?.coordinates]);

  return (
    <BaseMap
      viewState={viewState}
      deckProps={{
        onClick: onMapClick,
      }}
    >
      <EditMapLanes location={values} />
    </BaseMap>
  );
};
